import { COLORS } from "./sbPalette";

const TEXTURES = {
  texturedNavy: (
    <pattern id="texturedNavy" patternUnits="userSpaceOnUse" width="10" height="10">
      <rect width="14" height="14" fill={COLORS.dataNavy.main} />
      <image
        id="image0_233_7225"
        width="10"
        height="10"
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAjSURBVHgB7cuxAQAACIMw/P/oOnkAs2UmgyvIgkQFX8Ah9S8/6Rjpm4CQsQAAAABJRU5ErkJggg=="
      />
    </pattern>
  ),
  texturedCerulean: (
    <pattern id="texturedCerulean" patternUnits="userSpaceOnUse" width="14" height="14">
      <rect width="14" height="14" fill={COLORS.dataCerulean.main} />
      <image
        id="image0_233_7208"
        width="14"
        height="14"
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAZ0lEQVQ4T2NkYmL6/+/fP0YGHICQPC59YANxaSbXUJCZcJeiG0KJoSgGI7ucUkMxDMYXLLjCEm8YwyRhLqWqi2kSxjRJFYS8TUieqDAmNYLwqceZ4yi1ZNRgeAiOBsVoUGBmp6GXKgBLi0QX58gxUgAAAABJRU5ErkJggg=="
      />
    </pattern>
  ),
  texturedArctic: (
    <pattern id="texturedArctic" patternUnits="userSpaceOnUse" width="10" height="10">
      <rect width="10" height="10" fill={COLORS.dataArctic.main} />
      <image
        id="image0_233_7191"
        width="10"
        height="10"
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAnSURBVHgB7cuhDQAACAPBZ/+hiwCHob6fNKk5AO3sAgMHFl465wsbgnkY6XtRN5sAAAAASUVORK5CYII="
      />
    </pattern>
  ),
  texturedSky: (
    <pattern id="texturedSky" patternUnits="userSpaceOnUse" width="10" height="10">
      <rect width="10" height="10" fill={COLORS.dataSky.main} />
      <image
        id="image0_233_7174"
        width="10"
        height="10"
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAmSURBVHgB7cyxDQAACIRAdP+d1R38EhLag0zThBISEhJ6VvcQaAF2RwIgpbFHGgAAAABJRU5ErkJggg=="
      />
    </pattern>
  ),
  texturedLime: (
    <pattern id="texturedLime" patternUnits="userSpaceOnUse" width="15" height="15">
      <rect width="15" height="15" fill={COLORS.dataLime.main} />
      <image
        id="image0_233_7157"
        width="15"
        height="15"
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABWSURBVHgB7VRBDgAgCPL/n6Z7qylIhza5NDNgrSSCA7bVCiS1VTzbt4hX+xayZMKSqPPqtUu87sNBbnZN3MODa+E2efpbWEwWSSKTRX6TyaKj3r9ZtAAz1y/RBkk05AAAAABJRU5ErkJggg=="
      />
    </pattern>
  ),
  texturedCream: (
    <pattern id="texturedCream" patternUnits="userSpaceOnUse" width="15" height="15">
      <rect width="15" height="15" fill={COLORS.dataCream.main} />
      <image
        id="image0_233_7140"
        width="15"
        height="15"
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAB+SURBVHgBxZfLDQAgCEO7/9I4gcqvrTcE+hKjAgAQMC41PK6GCvrcZENTTha0FLQNbQVv60zho/xu8sqJVUVW70hWjPIqYuinwCU/X3xsCdxS3axQyzHfbAn0t0+FZv0UaDWOImYpENO8eTJMTUBLx9JzWbpMS19tmSTks9MBmrM5x8Yuoa4AAAAASUVORK5CYII="
      />
    </pattern>
  ),
  texturedPeach: (
    <pattern id="texturedPeach" patternUnits="userSpaceOnUse" width="15" height="15">
      <rect width="15" height="15" fill={COLORS.dataPeach.main} />
      <image
        id="image0_233_7123"
        width="15"
        height="15"
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABCSURBVHgB7dPBCgAgCAPQ2f//c12iSxGNEBzsgVcRdcCuz/rSkESvceB9nwFC2sQn/oo6rrfwjhcmTVRC/RXCjfUM3EIKF7NkXa8AAAAASUVORK5CYII="
      />
    </pattern>
  ),
  texturedGinger: (
    <pattern id="texturedGinger" patternUnits="userSpaceOnUse" width="15" height="15">
      <rect width="15" height="15" fill={COLORS.dataGinger.main} />
      <image
        id="image0_233_7106"
        width="15"
        height="15"
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFzSURBVHgB7ZixTsMwFEVvy9SBARbojBSJnZ0RBj4gP8DIBP/ARBd+gi+AmRlGpKpImdhAomO7tfcmrlRFThs7sr3kSHepX/RerefnmwB2nqgHhOOemtgWhg0PnFMFwlGYHK3IqD/qGOE4MjmyfYEjVNXnCI9yrExOK5kJeEE8lKtAbafUXG+otjDGztTJTW7VMBmg6nhV+U7NkQb11CV1hp6ejgzQDQ3P7WbcHI5/eHIAf3RcX6lTakkdUlfUI/VDfSEiGmgaorbRr98KRBywuUk42hGjtRUiDNrWlyI8L+kh3FADf1LfLWIV82GeCVaQTtPUIX4Kx+vAtaDguBbk5PQQ3nmGb2of9jo9xHWeJVanZ+jkPLvcZfr3z6jGwObkqWcuqLsUBYm600vtPHt6SoOmjwon1C+1QBo0PK+pG10dY+qWmiHdi+LM1DDeXoju9LDbeZZEc3po5zxLkn6OsdkPL6fnSKPzbPJDzk7PkUbnuQaFc1C+zu3dlwAAAABJRU5ErkJggg=="
      />
    </pattern>
  ),
  texturedRed: (
    <pattern id="texturedRed" patternUnits="userSpaceOnUse" width="40" height="40">
      <rect width="40" height="40" fill={COLORS.dataRed.main} />
      <image
        id="image0_233_7089"
        fillOpacity={0.5}
        width="40"
        height="40"
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALBSURBVHgB7VjBahRBEH1qFINESFxUjDdhIQHxE7wpggfFS27muufkA/QgImrwF/S0Xj0YEQTFKIjeFCJCzEEiiqBgLhGR9dV2zdrpVM/OJj2YQD94sFNd/Xp2qrumpgAbM+ScYX9KPjPst8lZVEcy/d2wsUROGPa9yhATOqcq6tbHKPmNbAb2t0ofTfUdw/bR72KK7JDDej1OfleOq03GltT3v+jvQRzv4EJ3jXxEniP/qOB+8if5hXxMXsHgSKYvh+Mi4iGSfy8hXCPvKdfUFnsyY6o5W5N+bw2JwCXyLHmd/AT3ZHzIdQMuWpIhvpIHyQfkncgNPSSP6o2MJNYP1+hBDouErx04T6u94dkOkctw6c2HzO1g4+FMpd9vje6hkcEidHN6PWn4NnTssl5P6Y0MI46t6Fddo5e2bpAfsf7JhJCFl9XXSoup9K+Sx6usIemrBbd3F+BC2Q/i81zntPAvBabUv0/+gDsv6/R3wR0cefuN6KCkrV9wL5RbqAYpDU6R+8gz5Aq5Sv7W8a3qy33eJM+Th339Ibh91vEcU8HXrVu/h2MYPMSyh6tuoc3qR7dQWMx9Jp/AhecF+QZ2hvDFX5EvdY7MXSnx36z+e/IkeYQ8UOK/ofaQFNaBnSkmdawoi8PaJrV+3zWaOhi+aORlIqnMD7f8lhQ4Hfi29QabNemba8g/nEd57SE5W/ZsUdssqM1CUdvMq3Zq/XCNbgq8AFejlznLwbur7FdsjarmTE36/hql8OuOll639XesthkEteqHdYekQEll4QeHX9tsG/0d80kZ+6g/DZejPwR2+UpaDWzi81rnVEUy/SHYOEEuGnapbaxyYFHnVEUy/VgEdgxyXwi5L5T7QrkvZN1Q7gsh94VyXyipfvSjPveFSpD7Qp5+7gvlvlAifXON3BcykPtCyH2h3BcqRe4LFfgL1LkLi4IZ+IsAAAAASUVORK5CYII="
      />
    </pattern>
  ),
  texturedMaroon: (
    <pattern id="texturedMaroon" patternUnits="userSpaceOnUse" width="10" height="10">
      <rect width="10" height="10" fill={COLORS.dataMaroon.main} />
      <image
        fillOpacity={0.5}
        id="image0_233_7072"
        width="10"
        height="10"
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAdSURBVHgB5cMxDQAACAOwBv+e4eGcgzUp7I9GhQME8AIBggwdPgAAAABJRU5ErkJggg=="
      />
    </pattern>
  ),
  texturedMagenta: (
    <pattern id="texturedMagenta" patternUnits="userSpaceOnUse" width="10" height="10">
      <rect width="10" height="10" fill={COLORS.dataMagenta.main} />
      <image
        fillOpacity={0.5}
        id="image0_233_7055"
        width="10"
        height="10"
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAALElEQVQYV2NkYGD4D8SMQIwN/MclAVdMsgKQdSAA14huAkEFGA4lyg14vQkAF9gGBz+1zjkAAAAASUVORK5CYII="
      />
    </pattern>
  ),
  forecasted: (
    <pattern id="forecasted" patternUnits="userSpaceOnUse" width="10" height="10">
      <image
        id="image0_357_1559"
        width="10"
        height="10"
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAG4SURBVHgB7dLJbcNAEERRkndn5XicguUcHI+y0plSSYAEgtvs00v9Ux8bDzUOgrv9fP/O83wZhPb47W8chKYB7+v/ehEJqAUPtzhATXhIFKA2PCQGUCMeEgGoFQ91B9SMh7oCasdD3QAt4KEugFbwUHNAS3ioKaA1PNQM0CIeagJoFQ9VB7SMh6oCWsdD1QA94KEqgF7wUHFAT3ioKKA3PFQM0CMeKgLoFQ9lA3rGQ1mA3vFQMiDxXiUBEu9TNCDxlkUBEm9dMCDxtgsCJN5+p4DEO+4QkHjn7QISL6xNQOKFtwIkXlwLQOLF9wYkXlpPQOKlNxIvr4l46WF80yA0DXgYn0hALXi4xQFqwkOiALXhITGAGvGQCECteKg7oGY81BVQOx7qBmgBD3UBtIKHmgNawkNNAa3hoWaAFvFQE0CreKg6oGU8VBXQOh6qBugBD1UB9IKHigN6wkNFAb3hoWKAHvFQEUCveCgb0DMeygL0joeSAYn3KgmQeJ+iAYm3LAqQeOuCAYm3XRAg8fY7BSTecYeAxDtvF5B4YW0CEi+8FSDx4loAEi++NyDx0noCEi+9iXh53QGj327HvltyTAAAAABJRU5ErkJggg=="
      />
    </pattern>
  ),
};

export { TEXTURES };
